<template>
  <div class="business-settings-inline-form">
    <v-form ref="addSellingPointForm" @submit.prevent="submit">
      <v-card
        flat
      >
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                autofocus
                dense
                outlined
                class="form-input"
                label="Naziv prodajnog mjesta"
                v-model="editablePointOfSale.name"
                :rules="[rules.req]"
                id="name"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                dense
                outlined
                class="form-input"
                label="Oznaka prodajnog mjesta"
                v-model="editablePointOfSale.location_id"
                autocomplete="off"
                persistent-hint
                hint="Samo brojevi i slova"
                @keypress="checkInput($event)"
                :rules="[rules.req]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                dense
                outlined
                class="form-input"
                label="Adresa"
                v-model="editablePointOfSale.address"
                :rules="[rules.req]"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                dense
                outlined
                class="form-input"
                label="Grad"
                v-model="editablePointOfSale.city"
                :rules="[rules.req]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="8" md="6">
              <v-text-field
                dense
                outlined
                class="form-input"
                label="Poštanski broj"
                v-model="editablePointOfSale.zip_code"
                :rules="[rules.req]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end form-footer-sticky">
          <v-btn
            class="btn-primary"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            <v-icon left small color="#fff">mdi-content-save</v-icon>
            Spremi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import rules from '@/plugins/rules'
import { df, auth } from '@/plugins/firebase'
import { clone, duck } from '@/plugins/utils'
import { v4 as uuidv4 } from 'uuid'
import countries from '@/mixins/countries'
import requestChecker from '@/mixins/requestChecker'

export default {
  name: 'AddSellingPoint',
  props: {
    pointOfSale: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    submitting: false,
    editablePointOfSale: {},
    initialPointOfSale: {},
    defultPointOfSale: {},
    error: {
      show: false,
      message: undefined
    },
    rules: {
      req: rules.req(),
      eq: rules.eq
    }
  }),
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  mixins: [countries, requestChecker],
  mounted () {
    document.onkeydown = this.handleKeyEvents

    this.submitting = false

    this.defultPointOfSale = Object.assign(
      this.defultPointOfSale,
      this.pointOfSale
    )
    this.editablePointOfSale = clone(this.pointOfSale)
    this.initialPointOfSale = Object.assign(this.initialPointOfSale, this.pointOfSale)

    this.registerRequestParams(this.editablePointOfSale)
  },
  methods: {
    checkInput (ev) {
      // change this with a custom directive  that accepts custom regex and checks input field
      const maskRe = /[A-Za-z0-9]/
      if (!maskRe.test(ev.key)) {
        ev.preventDefault()
        return false
      }
    },
    handleKeyEvents (e) {
      e = e || window.event
      if (e.keyCode === 9) {
        if (document.activeElement.id.includes('lastElement')) {
          e.preventDefault()
          document.getElementById('name').focus()
        }
      }
    },
    submit () {
      if (duck(this.editablePointOfSale, this.initialPointOfSale)) {
        this.showMsgBox({ text: this.$t('$vuetify.errors.noChangesInEntities'), actions: ['ok'], cancelBtnText: 'OK', color: 'error' })
        return
      }

      const that = this
      if (!this.$refs.addSellingPointForm.validate()) return
      this.submitting = true

      if (duck(this.editablePointOfSale, this.defultPointOfSale)) {
        return
      }

      try {
        const reqId = uuidv4()

        const payload = {
          action: {
            operation: 'update',
            entity: 'location',
            resource_id: this.pointOfSale.id,
            params: {
              ...this.editablePointOfSale,
              ...{ company_id: this.company.id }
            }
          }
        }

        const fullpayload = clone(payload.action.params)

        const cleanParams = this.getCleanParams(this.editablePointOfSale)
        Object.keys(cleanParams).forEach((key) => {
          if (key !== 'company_id') {
            delete payload.action.params[key]
          }
        })

        df.doc(`request/${reqId}`)
          .set({
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'location',
            payload: btoa(
              unescape(encodeURIComponent(JSON.stringify(payload)))
            )
          })
          .then(function (doc) {
            that.$emit('saved', fullpayload)
          })
          .catch(function (error) {
            // console.error('Error writing document: ', error)
            that.showMsgBox({
              text: error || 'Internal error',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
            that.submitting = false
          })
          .finally(() => {})
      } catch (err) {
        that.showMsgBox({
          text: err || 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        that.submitting = false
      }
    }
  }
}
</script>
<style scoped>
.form-input >>> .v-input__slot {
  border-radius: 12px !important;
  background: #ffffff !important;
  min-height: 40px !important;
}
.form-input >>> fieldset {
  border-color: #e5e7eb !important;
  border-width: 1px !important;
  border-radius: 12px !important;
}
.form-input >>> .v-input__slot:hover fieldset {
  border-color: #00BCD4 !important;
}
.form-input.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}
.form-input >>> input {
  font-size: 13px !important;
}
.btn-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
  text-transform: none !important;
}
.btn-primary:hover:not(:disabled) {
  background-color: #0097A7 !important;
}
.btn-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}

.business-settings-inline-form {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.business-settings-inline-form>>>form {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card__text {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.form-footer-sticky {
  flex: 0 0 auto;
  background: #fff;
  border-top: 1px solid #F3F4F6;
  padding: 16px 24px !important;
}
</style>
